import { CoreoAssociateMap, CoreoRecordSyncStatus } from '../../types';
import { READY_SYNC_STATES, READY_TO_BE_READY_SYNC_STATES } from '../../record-associate-sync-states';

export { READY_SYNC_STATES, READY_TO_BE_READY_SYNC_STATES };

export const checkAssociatesHaveState = (associates: CoreoAssociateMap, states: Set<CoreoRecordSyncStatus>): boolean => {
  if (!associates || Object.keys(associates).length === 0) {
    return true;
  }

  return Object.values(associates).every(records =>
    records.every(record => states.has(record.syncState) &&
    checkAssociatesHaveState(record.associates, states)
  ));
};


export const checkAssociatesReady = (associates: CoreoAssociateMap): boolean => {
  return checkAssociatesHaveState(associates, READY_SYNC_STATES);
};
